import { Checkbox, Paragraph } from '@digdir/designsystemet-react';
import { FC, Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../../types';
import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { TermostatstyringRadio } from '../../common/termostatstyringRadio';
import { useElektrisitetValidation } from '../useElektrisitetValidation';
import { elektrisitetSelectionFields } from '../utils';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

type OppvarmingElektriskCheckboxName = 'takvarme' | 'panelovn' | 'luftvarme';

interface Props {
  name: OppvarmingElektriskCheckboxName;
  description?: string;
}

// Common component for Panelovn, Gulvvarme, Takvarme, Luftvarme as they share the same structure with
// installasjonsår and termostatstyring
export const ElektrisitetCheckbox: FC<Props> = ({ name, description }) => {
  const { t } = useTranslation();
  const { register, formState, watch } = useFormContext<OppvarmingFormData>();
  const { validateElektrisitetSelection } = useElektrisitetValidation();

  const isSelected = watch(`elektrisk.value.${name}.selected`);
  const elektrisitetSelectionError = formState.errors?.elektrisk?.value?.[name]?.selected;

  return (
    <StyledCard isActive={isSelected}>
      <Checkbox
        aria-invalid={!!elektrisitetSelectionError}
        label={t(`form.oppvarming.elektrisitet.${name}.label`)}
        {...register(`elektrisk.value.${name}.selected`, {
          validate: validateElektrisitetSelection,
          deps: elektrisitetSelectionFields,
          shouldUnregister: true
        })}
      />
      {isSelected && (
        <Fragment>
          {description && <Paragraph>{description}</Paragraph>}

          <InstallasjonsArRadio
            name={`elektrisk.value.${name}.value`}
            translationKeyPrefix={`form.oppvarming.elektrisitet.${name}.installasjonsAr`}
          />
          <TermostatstyringRadio name={`elektrisk.value.${name}.value.termostatstyring`} />
        </Fragment>
      )}
    </StyledCard>
  );
};
